import * as v3 from './v3/parsers';
import * as v5 from './v5/parsers';

const parsers = process.env.NODE_CONFIG?.backend?.version === 'v5' ? v5 : v3;

export default parsers;
